import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";
import { PasswordInput } from "@/components/PasswordInput";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function PrimeiroAcesso() {
  const { user, loading, refresh, logout } = useAuth();
  const nav = useNavigate();
  const [nova, setNova] = useState("");
  const [conf, setConf] = useState("");
  const [saving, setSaving] = useState(false);

  if (loading || user === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (nova.length < 6) return toast.error("A senha deve ter ao menos 6 caracteres");
    if (nova !== conf) return toast.error("As senhas não conferem");
    setSaving(true);
    try {
      await api.post("/auth/force-change-password", { new: nova });
      await refresh();
      toast.success("Senha definida! Acesso liberado.");
      nav("/");
    } catch (e2) { toast.error(e2.response?.data?.detail || "Erro ao definir senha"); }
    finally { setSaving(false); }
  };

  return (
    <AuthShell
      title="Crie sua nova senha"
      subtitle="Por segurança, defina uma nova senha antes de acessar o sistema."
      footer={<button onClick={logout} className="text-sm text-muted-foreground mt-2" data-testid="pa-logout">Sair</button>}
    >
      <div className="rounded-md border border-primary/40 bg-primary/10 p-3 text-sm flex gap-2 mb-1" data-testid="pa-aviso">
        <ShieldCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
        <span>Este é o seu primeiro acesso, {user.name}. A senha temporária deixará de funcionar após esta etapa.</span>
      </div>
      <form onSubmit={submit} className="space-y-5" data-testid="primeiro-acesso-form">
        <div className="space-y-2"><Label>Nova senha</Label>
          <PasswordInput value={nova} onChange={(e) => setNova(e.target.value)} data-testid="pa-nova" /></div>
        <div className="space-y-2"><Label>Confirmar nova senha</Label>
          <PasswordInput value={conf} onChange={(e) => setConf(e.target.value)} data-testid="pa-conf" /></div>
        <Button type="submit" className="w-full h-12 text-base font-bold" disabled={saving} data-testid="pa-submit">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Salvar e acessar"}
        </Button>
      </form>
    </AuthShell>
  );
}
